var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('div',{staticClass:"font-weight-black display-4"},[_vm._v("404")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }